var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [_c("breadcrumb", { attrs: { breadcrumbConfig: _vm.dataList } })],
        1
      ),
      _c("div", { staticClass: "table" }, [
        _c(
          "div",
          { staticClass: "btnBox" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("供应商分类"),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            "default-first-option": "",
                          },
                          model: {
                            value: _vm.queryForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "category", $$v)
                            },
                            expression: "queryForm.category",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.supplier_category,
                          function (items, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: items.dictName,
                                value: items.dictName,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("供应商名称"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "name", $$v)
                          },
                          expression: "queryForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("供应商编码"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.supplierCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "supplierCode", $$v)
                          },
                          expression: "queryForm.supplierCode",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("联系电话"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.contactNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "contactNumber", $$v)
                          },
                          expression: "queryForm.contactNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "mini" },
                        on: { click: _vm.reset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-buttons",
                    staticStyle: { width: "100%" },
                  },
                  [
                    _c("div", { staticClass: "button-container" }, [
                      _c(
                        "div",
                        { staticClass: "button-group left-group" },
                        [
                          _vm.parArray.indexOf("supplier-add") != -1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "background-color": "#fff",
                                    height: "24px",
                                    padding: "0 12px",
                                    "line-height": "22px",
                                  },
                                  attrs: { plain: "", size: "mini" },
                                  on: { click: _vm.handleAdd },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [_vm._v(" 新增供应商 ")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.parArray.indexOf("supplier-export") != -1
                            ? _c(
                                "el-dropdown",
                                { on: { command: _vm.handleExportCommand } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        height: "24px",
                                        padding: "1px 12px",
                                        "line-height": "22px",
                                      },
                                      attrs: { plain: "", size: "mini" },
                                    },
                                    [
                                      _vm._v(" 导出"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "exportAll" } },
                                        [_vm._v(" 导出列表 ")]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          class: {
                                            "is-disabled": !_vm.hasSelection,
                                          },
                                          attrs: {
                                            disabled: !_vm.hasSelection,
                                            command: "exportSelected",
                                          },
                                        },
                                        [_vm._v(" 导出本页勾选的数据 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: {
              padding: "0 10px",
              "background-color": "#fff",
              margin: "0 -10px",
            },
          },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: '"always"',
                },
              ],
              attrs: {
                border: "",
                column: _vm.columns,
                align: "center",
                data: _vm.tableData.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50, 200],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
                orderStatistics: _vm.page.totalNum,
                statisticText: "当前列表统计总供应商数",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
                refresh: _vm.fetchData,
                "selection-change": _vm.handleSelectionChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("supplier-dialog", {
        attrs: {
          visible: _vm.dialogVisible,
          type: _vm.dialogType,
          "form-data": _vm.formLabel,
          "supplier-names": _vm.supplierNames,
          "settlement-options": _vm.dictionaries.goods_type,
          "remote-method": _vm.remoteSMethod,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          submit: _vm.handleSupplierSubmit,
          closed: _vm.resetForm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }